import {FolderObjType} from '@crema/types/models/apps/Contact';

const folderList: FolderObjType[] = [
  {id: 121, name: 'All', alias: 'all', icon: 'user'},
  {id: 122, name: 'Frequent', alias: 'frequent', icon: 'clone'},
  {id: 124, name: 'Starred', alias: 'starred', icon: 'star'},
];
export default folderList;
